import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubble5: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBubble5"><Path d="M22 12C22 6.6875 18.1111 3.5 12 3.5C5.88889 3.5 2 6.6875 2 12C2 13.3793 2.94684 15.7215 3.09242 16.0734C3.10526 16.1045 3.11797 16.1328 3.12953 16.1644C3.23023 16.4392 3.65129 17.9233 2 20.1217C4.22222 21.1842 6.58221 19.4375 6.58221 19.4375C8.215 20.3039 10.1578 20.5 12 20.5C18.1111 20.5 22 17.3125 22 12Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBubble5;
